/**
 * Session replay never runs on capability routes (sharing review r7 #2):
 * external app links, shared guest apps, and sign-in/sign-up with its callbacks
 * carry bearer link tokens in URLs and DOM attributes (and the Link wallet
 * connect completion, which holds an OAuth code), and PostHog
 * compresses replay snapshots before any before_send redaction can see
 * them. The recorder is held off on the first page if it is one of these
 * and stopped on navigation into one, then resumed on a normal route (only
 * if it was running or held back by this guard; it never starts a
 * recording the project's settings did not).
 */

/** Capability routes: also the pattern inline scripts (Meta Pixel) check before loading. */
export const CAPABILITY_ROUTE_PATTERN =
  /^\/(?:share\/apps\/|share\/guest-apps\/|connect\/phone(?:\/|$)|auth(?:\/|$)|login(?:\/|$)|signup(?:\/|$)|agent-payments\/)/;

export function isReplayBlockedPath(pathname: string): boolean {
  return CAPABILITY_ROUTE_PATTERN.test(pathname);
}

export type ReplayRecorder = {
  sessionRecordingStarted: () => boolean;
  stopSessionRecording: () => void;
  startSessionRecording: () => void;
};

export function createReplayRouteGuard(
  recorder: ReplayRecorder,
  options: { startedBlocked: boolean }
): { sync: (pathname: string) => void } {
  // Whether this guard is holding a recording back (stopped it, or disabled it at a blocked first page).
  let held = options.startedBlocked;
  return {
    sync: (pathname) => {
      if (isReplayBlockedPath(pathname)) {
        if (recorder.sessionRecordingStarted()) {
          recorder.stopSessionRecording();
          held = true;
        }
        return;
      }
      if (held) {
        held = false;
        recorder.startSessionRecording();
      }
    },
  };
}
